<template>
  <div class="app-main-content railwayStation">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <el-form
            :inline="true"
            label-width="50px"
            label-position="left"
            @submit.native.prevent="filter.pageNum=1;toQuery()"
          >
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('common.btn.query')">
                <el-input
                  v-model="filter.likeName"
                  no="likeName"
                  :placeholder="$t('common.tips.fuzzySearch')"
                  style="width:310px"
                />
              </el-form-item>
              <el-button no="query" size="mini" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
              <el-button no="new" size="mini" type="primary" @click="showAddDialog">{{ $t('common.btn.new') }}</el-button>
              <el-button no="edit" size="mini" type="primary" @click="showEditDialog">{{ $t('common.btn.edit') }}</el-button>
              <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
            </div>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <!--          config-module="101601"-->
          <cargo-ag-grid
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <station-edit-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      :railway-station="editDialog.railwayStation"
      @saveCallBack="editDialog.saveCallBack"
      @close="editDialog.visible=false"
    />
    <!-- 新增弹窗（非平台维护） -->
    <select-station-template-list-dialog
      :visible.sync="templateListDialog.visible"
      @addCallBack="templateListDialog.addCallBack"
      @close="templateListDialog.visible=false"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import baseCity from './components/baseCity'
import StationEditDialog from '@/views/cargo/v0/Information/components/StationEditDialog'
import SelectStationTemplateListDialog from '@/views/cargo/v0/Information/components/SelectStationTemplateListDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getUserInfo } from '@/utils/auth'
import { getCountryList } from '@/api/country'
import * as railwayStationApi from '@/api/basicData/railwayStation'
import { saveLocation, saveLocations } from '@/api/location'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import lang from '@/lang'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'RailwayStation',
  components: { SelectStationTemplateListDialog, StationEditDialog, cargoAdvanceSelect, baseCity },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF'),
              action: function() {
                self.exportPdfHandler()
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 100
        }, {
          headerName: this.$t('baseInfo.city.code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('baseInfo.city.chineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.englishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          width: 200,
          valueGetter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.data.countryCode, 'name')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityCode'),
          field: 'cityCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CityName'),
          field: 'cityName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Region'),
          field: 'region',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeCode'),
          field: 'interchangeCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsoCode'),
          field: 'isoCode',
          width: 200
        }
      ],
      rowData: [],
      countryList: [],
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        railwayStation: null,
        saveCallBack: () => {}
      },
      templateListDialog: {
        visible: false,
        addCallBack: () => {}
      },
      platformDialog: {
        visible: false
      },
      isAddedFromTemplate: this.$store.getters.tenantId === 1, // WALLTECH_PLATFORM
      initFormData: {
        uuid: '',
        version: 1,
        serialNumber: 0,
        code: '',
        englishName: '',
        chineseName: '',
        countryCode: '',
        region: '',
        cityCode: '',
        cityName: '',
        interchangeCode: '',
        isoCode: ''
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  beforeCreate() {
    const self = this
    getCountryList().then(res => {
      self.countryList = res.data
      self.configCountryLang(self.countryList)
      self.toQuery()
      document.countryList = self.countryList
    })
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  beforeDestroy() {
    document.countryList = undefined
  },
  methods: {
    configCountryLang(countryList) {
      if (countryList.length === 0) {
        return
      }
      for (const item of countryList) {
        item.countryName = this.$i18n.locale === 'zh' ? item.chineseName : item.name
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      railwayStationApi.loadRailwayStation(self.filter).then(res => {
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    bindCountryName(data) {
      if (!this.countryList || this.countryList.length === 0 || data.length === 0) {
        return
      }
      if (data[0].countryName) {
        return
      }
      const map = new Map()
      for (const item of this.countryList) {
        map.set(item.code, item.countryName)
      }
      for (const item of data) {
        item.countryName = map.get(item.countryCode)
      }
    },
    showAddDialog() {
      if (this.tenantId === this.PLATFORM_TENANT_ID) {
        this.editDialog.saveCallBack = this.addCallBackHandler
        this.editDialog.visible = true
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('Information.RailwayStation')
        this.editDialog.railwayStation = this.initFormData
      } else {
        this.templateListDialog.addCallBack = this.addCallBackHandler
        this.templateListDialog.visible = true
      }
    },
    showEditDialog() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.railwayStation = row
      this.editDialog.title = this.$t('CargoMsg.Cargo_ModifyRailwayStation')
      this.editDialog.saveCallBack = this.addCallBackHandler
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    save() {
      const self = this
      const form = self.editDialog.form
      const railwayStation = {}
      railwayStation.serialNumber = form.serialNumber
      railwayStation.englishName = form.englishName
      railwayStation.chineseName = form.chineseName
      railwayStation.countryCode = form.countryCode
      railwayStation.region = form.region
      railwayStation.interchangeCode = form.interchangeCode
      railwayStation.code = form.code
      if (this.location) {
        railwayStation.cityName = form.cityName
        railwayStation.cityCode = this.location.cityCode
      }
      if (this.isAddedFromTemplate) {
        if (!railwayStation.code) {
          this.$message.warning(this.$t('Information.CodeCannotBeEmpty'))
          return
        }
        if (!railwayStation.englishName) {
          this.$message.warning(this.$t('Information.EnglishNameCannotBeEmpty'))
          return
        }
        railwayStation.isoCode = form.isoCode
        railwayStation.interchangeCode = form.interchangeCode
      }
      if (this.isAddedFromTemplate && !railwayStation.uuid) {
        railwayStationApi.savePlatformRailwayStation(railwayStation).then(resp => {
          this.rowData.push(resp.data)
          this.savePortsHandler()
        })
      } else {
        railwayStationApi.save(railwayStation).then(resp => {
          this.savePortsHandler()
        })
      }
    },
    remove() {
      const self = this
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const codes = rows.map(row => row.code)
      railwayStationApi.getUsedRailwayStations(codes).then(resp => {
        const data = resp.data
        if (!data || data.length === 0) {
          self.$confirm(this.$t('Information.ConfirmDeletionOfTheSite'), this.$t('Message.Tips'), { closeOnClickModal: false }).then(() => {
            const uuids = rows.map(row => row.uuid)
            railwayStationApi.deleteRailwayStationsByUUID(uuids).then(resp => {
              syncSpecificBasicData(basicCacheKeys.basic_data_RailwayStation)
              self.$message.success(this.$t('common.tips.deleteSuccess'))
              self.toQuery()
            })
          })
        } else {
          let msg = '\n' + this.$t('Information.TheByTheBusinessDeleted') + '\n\n'
          if (data.length < 21) {
            msg += data.join(', ')
          } else {
            msg += data.slice(0, 20).join(', ') + '...'
          }
          self.$confirm(msg, this.$t('Message.Tips'), { confirmButtonText: this.$t('constant.yes'), closeOnClickModal: false })
        }
      })
    },
    showPlatform() {
      if (document.resetBaseCity) {
        document.resetBaseCity()
      } else {
        setTimeout(() => {
          document.resetBaseCity()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform(location) {
      const self = this
      const row = location
      if (row.length === 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_CityNotSelected'))
        return
      }
      const form = {
        code: row.code,
        chineseName: row.chineseName,
        englishName: row.englishName,
        locationCode: row.locationCode,
        countryCode: row.countryCode
      }
      saveLocations([form]).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(this.$t('Information.AddedSuccessfully'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    },
    selectLocalHandler(location) {
      this.editDialoglocation = location
      this.editDialog.form.cityName = location.englishName
    },
    cityClickHandler() {
      // if (locationSearchWindow == null) {
      //   locationSearchWindow = new LocationSearchWindow();
      //   locationSearchWindow.selectLocationBack = citySelectHandler;
      // }
      // PopUpUtils.addPopUp(locationSearchWindow,this, true);
    },
    savePortsHandler() {
      // todo CacheManager.getInstance().loadCache(RailwayStation.CODE_NAME);
      this.editDialog.visible = false
      this.$message.success(self.$t('common.tips.saveSuccess'))
    },
    addCallBackHandler() {
      this.toQuery()
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('Information.RailwayStation'), this.rowData, columnDefs)
    },
    exportPdfHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportPdf(this.$t('Information.RailwayStation'), this.rowData, columnDefs)
    }
  }
}
</script>

<style lang="scss">
  #app {
    .city .app-main-page {
      height: calc(100vh - 100px);
    }
    .hasTagsView {
      .city .app-main-page {
        height: calc(100vh - 130px);
      }
    }
  }
</style>
